import type { PlanDecision } from '../api.ts';
import * as wording from '../wording.ts';

/**
 * The plan's `## Decisions made` (one-shot ads US-021): every question an
 * autopilot planner would have asked, with what it chose, why, and the source
 * that settled it. A record, never a choice — the plan already says it; a
 * change goes in the planning conversation. Shown on the content page's plan
 * panel and in the board's planning panel in place of a question.
 */
export function Decisions({
  decisions,
  whenEmpty = 'hide',
}: {
  readonly decisions: readonly PlanDecision[];
  /** `say` writes a line when there are none yet (the planning panel); `hide` draws nothing. */
  readonly whenEmpty?: 'hide' | 'say';
}) {
  if (decisions.length === 0) {
    return whenEmpty === 'say' ? <p className="muted">{wording.DECISIONS_NONE}</p> : null;
  }
  return (
    <section className="script-changes decisions" aria-label={wording.DECISIONS_TITLE}>
      <strong>{wording.DECISIONS_TITLE}</strong>
      <p className="field__hint">{wording.DECISIONS_HINT}</p>
      <ol className="script-changes__list">
        {decisions.map((decision) => (
          <li key={decision.line}>
            <span className="script-changes__line">
              {decision.question} — <strong>{decision.chosen}</strong>
            </span>
            <span className="script-changes__why">
              {decision.why} · {decision.source}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
